import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// @material-ui/core components
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  LinearProgress,
  TextField,
  IconButton,
  Icon,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
// @material-ui/styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../../assets/jss/layouts/appStyle";
// core components
import { GradingSchemaRepository } from "./GradingSchemaRepository";
import { LOCALE } from "../../../properties/Locale";
import EntityMetadata from "../../../common/components/EntityMetadata";
import CardBody from "../../../common/components/Card/CardBody";
import Card from "../../../common/components/Card/Card.js";
import CardHeader from "../../../common/components/Card/CardHeader.js";

const useStyles = makeStyles(styles);

export default function GradingSchemaDetailsComponent(props) {
  const classes = useStyles();
  const [gradingSchemaId] = useState(props.match.params.gradingSchemaId);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    const loadGradingSchema = (id) => {
      setLoading(true);
      GradingSchemaRepository.fetchGradingSchema(id).then((res) => {
        setData(res.data);
        setLoading(false);
      });
    };

    loadGradingSchema(gradingSchemaId);
  }, [gradingSchemaId]);

  return (
    <div>
      <Card>
        <Dialog
          open={true}
          maxWidth="md"
          fullWidth={true}
          onClose={() => {}}
          aria-labelledby="form-dialog-title"
          PaperProps={{
            style: {
              overflowY: "unset",
            },
          }}
        >
          <CardHeader color="theme">
            <h4 className={classes.cardTitleWhite}>
              {`${LOCALE.grading_schema_details}${
                data?.name ? ": " + data?.name : ""
              }`}
              <Link
                to={`/app/configuration/gradingSchema/`}
                style={{ textDecoration: "none" }}
              >
                <IconButton
                  style={{ float: "right", color: "white" }}
                  aria-label="close"
                >
                  <Icon>close</Icon>
                </IconButton>
              </Link>
            </h4>
          </CardHeader>
          <CardBody>
            {loading ? <LinearProgress /> : ""}
            <div>
              <DialogContent>
                <TextField
                  id="name"
                  label="Name"
                  fullWidth={true}
                  size="small"
                  value={data?.name ? data?.name : ""}
                  margin="normal"
                  variant="outlined"
                  InputProps={{
                    readOnly: true,
                  }}
                />
                <FormControlLabel
                  size="small"
                  control={
                    <Checkbox
                      name={LOCALE.grading_schema_locked}
                      color="primary"
                      checked={data?.locked ? true : false}
                    />
                  }
                  label={LOCALE.grading_schema_locked}
                />
                <EntityMetadata data={data} />
              </DialogContent>
              <DialogActions>
                <Link
                  to={`/app/configuration/gradingSchema/`}
                  style={{ textDecoration: "none" }}
                >
                  <Button size="small" variant="outlined" color="secondary">
                    {LOCALE.close}
                  </Button>
                </Link>
              </DialogActions>
            </div>
          </CardBody>
        </Dialog>
      </Card>
    </div>
  );
}
